import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectHeapAppId } from '../utils/selectors';

declare global {
  interface Window {
    heap: {
      load: (appUrl: string, config?: Record<string, unknown>) => void;
      push: (...args: unknown[]) => void;
      [key: string]: unknown;
    };
  }
}
const loadHeap = (appId: string) => {
  window.heap = window.heap || [];
  window.heap.appid = appId;

  const scriptElement = document.createElement('script');
  scriptElement.id = 'heap';
  scriptElement.type = 'text/javascript';
  scriptElement.async = true;
  scriptElement.src = `https://www.aexp-static.com/cdaas/oneap/heap-${appId}.js`;
  const firstScriptElement = document.querySelectorAll('script')[0];
  firstScriptElement?.parentNode?.insertBefore(
    scriptElement,
    firstScriptElement
  );
};

const useHeapAnalytics = () => {
  const heapAppId = useSelector(selectHeapAppId);
  const isBrowser = global.BROWSER;

  useEffect(() => {
    loadHeap(heapAppId);
  }, [heapAppId, isBrowser]);
};

export default useHeapAnalytics;
